import GET_AFFILIATE_NETWORK from '@/graphql/Affiliate/getAffiliateNetwork.gql';
import GET_CONNECTED_AFFILIATE_NETWORKS from '@/graphql/Affiliate/getConnectedAffiliateNetworks.gql';
import CREATE_AFFILIATE_NETWORK from '@/graphql/Affiliate/createAffiliateNetwork.gql';
import DELETE_AFFILIATE_NETWORK from '@/graphql/Affiliate/deleteAffiliateNetwork.gql';
import UPDATE_AFFILIATE_NETWORK from '@/graphql/Affiliate/updateAffiliateNetwork.gql';
import GET_AFFILIATE_NETWORK_BY_ID from '@/graphql/Affiliate/getAffiliateNetworkById.gql';
import GET_CONNECTED_AFFILIATES from '@/graphql/Affiliate/getConnectedAffiliates.gql';
import GET_CREDENTIALS from '@/graphql/Affiliate/getCredentials.gql';
import GET_MEDIA_IDS from '@/graphql/Affiliate/getMediaIds.gql';
import GET_POSTBACK_URL from '@/graphql/Affiliate/getPostbackUrl.gql';
import GET_DAISYCOM_OAUTH_URL from '@/graphql/Affiliate/daisycon-oauth/getDaisyconOauthUrl.gql';
import RECEIVE_DAISYCON_OAUTH_TOKEN from '@/graphql/Affiliate/daisycon-oauth/receiveDaisyconOauthToken.gql';
import SET_AFFILIATE_NETWORK_PROGRAM_EVENT from '@/graphql/Affiliate/setAffiliateNetworkProgramEvent.gql';
import { graphClient, authClient } from '../main';

export default class AffiliateNetworkResource {
    async get () {
        return await graphClient.query({
            query: GET_AFFILIATE_NETWORK,
            update: data => data.affiliateNetworks
        })
    }

    async getConnected () {
        return await authClient.query({
            query: GET_CONNECTED_AFFILIATE_NETWORKS,
            update: data => data.connectedAffiliateNetworks
        })
    }

    async getById (id) {
        return await graphClient.query({
            query: GET_AFFILIATE_NETWORK_BY_ID,
            variables: {
                id: id
            },
            update: data => data.affiliateNetworks
        })
    }

    async getByStatusId (id) {
        return await graphClient.query({
            query: GET_AFFILIATE_NETWORK,
            variables: {
                status_id: id
            },
            update: data => data.affiliateNetworks
        })
    }

    async create (credentials, networkId, networkName, websiteId, currency, accountName, accountColor) {
        return await authClient.mutate({
            client: 'authClient',
            mutation: CREATE_AFFILIATE_NETWORK,
            variables: {
                credentials: credentials,
                network_id: networkId,
                network_name: networkName,
                website_id: websiteId,
                currency: currency,
                account_name: accountName,
                account_color: accountColor
            }
        })
    }

    async update (credentials, accountId, networkName, networkId, currency, websiteId, accountName, accountColor) {
        return await authClient.mutate({
            client: 'authClient',
            mutation: UPDATE_AFFILIATE_NETWORK,
            variables: {
                credentials: credentials,
                account_id: accountId,
                network_name: networkName,
                network_id: networkId,
                currency: currency,
                website_id: websiteId,
                account_name: accountName,
                account_color: accountColor
            }
        })
    }

    async delete (websiteId, accountId) {
        return await authClient.mutate({
            client: 'authClient',
            mutation: DELETE_AFFILIATE_NETWORK,
            variables: {
                websiteId: websiteId,
                accountId: accountId
            }
        })
    }

    async getMediaIds (websiteId) {
        return await authClient.query({
            query: GET_MEDIA_IDS,
            variables: {
                websiteId: websiteId
            },
            update: data => data.me.websites
        })
    }

    async getConnectedAffiliates (websiteId, mediaIds) {
        return await authClient.query({
            query: GET_CONNECTED_AFFILIATES,
            variables: {
                websiteId: websiteId,
                mediaIds: mediaIds
            },
            update: data => data.me.websites.affiliateNetwork
        })
    }

    async getCredentials (websiteId, mediaIds, affiliateId) {
        return await authClient.query({
            query: GET_CREDENTIALS,
            variables: {
                websiteId: websiteId,
                mediaIds: mediaIds,
                affiliateId: affiliateId
            },
            update: data => data.me.websites.affiliateNetwork
        })
    }

    async generatePostback (mediaId) {
        let mutation = await authClient.mutate({
            client: 'authClient',
            mutation: GET_POSTBACK_URL,
            variables: {
                mediaId: mediaId
            },
        })

        return mutation.data.postbackGenerateWebhook
    }

    async generateDaisyconOauthUrl (websiteId, state) {
        let mutation = await authClient.mutate({
            client: 'authClient',
            mutation: GET_DAISYCOM_OAUTH_URL,
            variables: {
                websiteId: websiteId,
                state: state
            },
        })

        return mutation.data.generateDaisyconOauthUrl
    }

    async receiveDaisyconOauthToken (code, websiteId) {
        let mutation = await authClient.mutate({
            client: 'authClient',
            mutation: RECEIVE_DAISYCON_OAUTH_TOKEN,
            variables: {
                code: code,
                websiteId: websiteId
            },
        })

        return mutation.data.receiveDaisyconOauthToken
    }

    async setProgramEvent (programEvent) {
        return await authClient.mutate({
            client: 'authClient',
            mutation: SET_AFFILIATE_NETWORK_PROGRAM_EVENT,
            variables: {
                program_name: programEvent.program_name,
                affiliate_network_account_id: programEvent.affiliate_network_account_id,
                event_name: programEvent.event_name,
                event_params: JSON.stringify(programEvent.event_params),
            }
        })
    }
}
